module.exports = __webpack_public_path__ + "static/media/b18.2b823de9.png";